import {
  AppBar,
  Box,
  Button,
  Grid,
  TextField,
  Toolbar,
  Typography,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import SendIcon from '@material-ui/icons/SendRounded';
import AttachFile from '@material-ui/icons/AttachFileRounded';
import { makeStyles } from '@material-ui/styles';
import BreadCrumb from '../../../../Components/BreadCrumb';
import { Link, useHistory } from 'react-router-dom';
import routes from '../../../../Utils/routes.json';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import EditOutlined from '@material-ui/icons/EditOutlined';
import { useEffect, useState } from 'react';
import KenCard from '../../../../global_components/KenCard';
import KenGrid from '../../../../global_components/KenGrid';
import KenPopover from '../../../../Components/KenPopOver';
import KenDialogBox from '../../../../global_components/KenDialogBox';
import KenSelectWrap from '../../../../global_components/KenSelect';
import { RiFilterLine } from 'react-icons/ri';
import Kentable from '../../../../global_components/KenTable/kentable';
import { Message } from '@material-ui/icons';
import ChatInput from '../../components/ChatInput';
import {
  getStudentStatusData,
  postStudentStatusData,
} from '../../../../Utils/apiServices';
// test
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Input from '@material-ui/core/Input';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import Checkbox from '@material-ui/core/Checkbox';
// Icons
import EditIcon from '@material-ui/icons/EditOutlined';
import DoneIcon from '@material-ui/icons/DoneAllTwoTone';
import RevertIcon from '@material-ui/icons/NotInterestedOutlined';
import KenAutoComplete from '../../../../global_components/KenAutoComplete/index';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import moment from 'moment';
import ChatLayout from '../../components/ChatLayout';
import KenGridEditable from '../../../../global_components/kenEditDataGrid/kenGridEditable';
import '../../../../style/index.css';
import KenGridEditableData from '../../../../global_components/kenEditDataGrid/KenGridEcditableForStudentStatus';
import KenInputField from '../../../../global_components/KenInputField/kenInputField2';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { sendMailStudentStatus } from '../../../../Utils/sendMail';
const arrayBreadCrumb = [
  // { head: 'ADMIN PORTAL', url: routes.adminManagement },
  {
    head: 'EXAM',
    url: routes.exam,
  },
  {
    head: 'STUDENT STATUS',
  },
];

const chatData = [
  {
    sender: true,
    message: `Hey, Could you please let me know which chapters I have to cover
  in UX/UI paper?`,
    profilePic: 'https://ptetutorials.com/images/user-profile.png',
    time: '3 days ago',
  },
  {
    sender: false,
    message: `Hi Nandhini, you should include first 8 chapters in mid semester
    exam.`,
    profilePic: '',
    time: '3 days ago',
  },
  {
    sender: true,
    message: `Okay, Thank you gentleman!`,
    profilePic: 'https://ptetutorials.com/images/user-profile.png',
    time: '3 days ago',
  },
];

const ActionCellSendMessage = (row) => {
  const classes = useStyles();

  // Message Modal
  const [messageDialog, setMessageDialog] = useState(false);

  function handleMessageDialog() {
    setMessageDialog((prevState) => !prevState);
  }
  const { id } = row.row.values;

  const handleClick = () => {
    handleMessageDialog();
  };

  const [chats, setChats] = useState(chatData);
  const [typedMessage, setTypedMessage] = useState(
    'Anytime, You are always welcome!'
  );

  const messageChangeHandler = (e) => {
    setTypedMessage(e.target.value);
  };

  const sendMessageHandler = () => {
    if (!typedMessage) {
      return;
    }

    setChats((prev) => {
      return [
        ...prev,
        {
          sender: false,
          message: typedMessage,
          profilePic: '',
          time: moment(new Date()).fromNow(),
        },
      ];
    });

    setTypedMessage('');
  };
  return (
    <>
      <Message
        style={{
          color: '#092682',
          cursor: 'pointer',
        }}
        className="m-0"
        onClick={handleClick}
      />
      {/* Message Modal */}
      <KenDialogBox
        title={
          <Typography
            variant="p"
            className={classes.modalHeader}
            style={{ display: 'flex', alignItems: 'center ' }}
          >
            <p>
              <img
                style={{ borderRadius: '50%', marginRight: '10px' }}
                width="40"
                height="40"
                src={'http://dummyimage.com/174x172.png/5fa2dd/ffffff'}
                alt="user"
              />
              {'Jane Cooper'}
            </p>

            <p>A - 12345</p>
            <p>Campus 1</p>
            <p>Course 1</p>
          </Typography>
        }
        open={messageDialog}
        handleClose={() => handleMessageDialog()}
        hidePositiveButton={true}
        hideNegativeButton={true}
        maxWidth="md"
        dividers
      >
        <div className="chat-box-part">
          <ChatLayout chats={chats} />

          <ChatInput
            typedMessage={typedMessage}
            messageChangeHandler={messageChangeHandler}
            sendMessageHandler={sendMessageHandler}
          />
        </div>
      </KenDialogBox>
    </>
  );
};
const ActionCellEdit = (row, isUpdating) => {
  const { id } = row.row.values;

  const editHandler = () => {
    console.log(id, 'Editing started');
  };
  return <EditOutlined className="m-0" onClick={editHandler} />;
};

const CellWithButton = (row) => {
  const classes = useStyles();
  const { eligibility_status } = row.row.values;

  console.log({ eligibility_status });

  let classOfBtn;
  if (eligibility_status === 'At Risk') {
    classOfBtn = classes.normal;
  } else if (eligibility_status === 'Not eligible') {
    classOfBtn = classes.error;
  } else {
    classOfBtn = classes.medium;
  }

  return (
    <Box>
      <Button
        variant="primary"
        component={Link}
        className={classOfBtn}
        // to={`${routes.currentProgrammes}/${id}/details`}
      >
        {eligibility_status}
      </Button>
    </Box>
  );
};

const UserCell = (row, name) => {
  return (
    <p>
      <img
        style={{ borderRadius: '50%', marginRight: '10px' }}
        width="40"
        height="40"
        src={row}
        alt="user"
      />
      {name}
    </p>
  );
};

const data = [
  {
    id: 1,
    name: UserCell(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Jane Cooper'
    ),
    id_no: 'A - 12345',
    campus: 'Campus 1',
    course: 'Course 1',
    eligibility_status: 'Eligible',
    reason: 'Reason 1',
  },
  {
    id: 2,
    name: UserCell(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Wade Warren'
    ),
    id_no: 'A - 02345',
    campus: 'Campus 1',
    course: 'Course 1',
    eligibility_status: 'At Risk',
    reason: 'Reason 1',
  },
  {
    id: 3,
    name: UserCell(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Cameron Williamson'
    ),
    id_no: 'A - 03345',
    campus: 'Campus 1',
    course: 'Course 1',
    eligibility_status: 'Not eligible',
    reason: 'Reason 1',
  },
  {
    id: 4,
    name: UserCell(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Jane Cooper'
    ),
    id_no: 'A - 12345',
    campus: 'Campus 1',
    course: 'Course 1',
    eligibility_status: 'Eligible',
    reason: 'Reason 1',
  },
  {
    id: 5,
    name: UserCell(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Wade Warren'
    ),
    id_no: 'A - 02345',
    campus: 'Campus 1',
    course: 'Course 1',
    eligibility_status: 'At Risk',
    reason: 'Reason 1',
  },
  {
    id: 6,
    name: UserCell(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Cameron Williamson'
    ),
    id_no: 'A - 03345',
    campus: 'Campus 1',
    course: 'Course 1',
    eligibility_status: 'Not eligible',
    reason: 'Reason 1',
  },
  {
    id: 7,
    name: UserCell(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Jane Cooper'
    ),
    id_no: 'A - 12345',
    campus: 'Campus 1',
    course: 'Course 1',
    eligibility_status: 'Eligible',
    reason: 'Reason 1',
  },
  {
    id: 8,
    name: UserCell(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Wade Warren'
    ),
    id_no: 'A - 02345',
    campus: 'Campus 1',
    course: 'Course 1',
    eligibility_status: 'At Risk',
    reason: 'Reason 1',
  },
  {
    id: 9,
    name: UserCell(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Cameron Williamson'
    ),
    id_no: 'A - 03345',
    campus: 'Campus 1',
    course: 'Course 1',
    eligibility_status: 'Not eligible',
    reason: 'Reason 1',
  },
  {
    id: 10,
    name: UserCell(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Jane Cooper'
    ),
    id_no: 'A - 12345',
    campus: 'Campus 1',
    course: 'Course 1',
    eligibility_status: 'Eligible',
    reason: 'Reason 1',
  },
];

const useStyles = makeStyles((theme) => ({
  breadCrumbWrapper: {
    margin: '15px 0',
  },
  header: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },
  subHeaderTitle: {
    width: '100%',
  },
  modalHeader: {
    fontWeight: 'normal',
    fontSize: '14px',
    display: 'flex',
    alignItems: 'center',
    '& p': {
      marginRight: '25px',
    },
  },
  addButton: {
    color: 'white',
    fontWeight: 'bold',
    textDecoration: 'none',
    textTransform: 'none',
    '&:hover': {
      color: 'white',
      borderBottom: '1px solid white',
    },
  },
  mainActions: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '2rem 0 1rem',
  },
  error: {
    background: 'rgba(241, 75, 45, 0.2)',
    borderRadius: '40px',
    fontSize: '10px',
    margin: '5px  5px',
    color: '#c12002',
    width: '101px',
    height: '25px',

    '&:hover': {
      color: '#c12002',
      background: 'rgba(241, 75, 45, 0.2)',
    },
    // color: '#FFFFFF',
    // background: '#EB5757',
    // borderRadius: 15,
    // fontSize: '10px',
    // fontWeight: 'bold',
    // margin: '0 5px',
    // width: '102px',
  },
  normal: {
    color: '#02ab4a',
    background: 'rgba(138, 245, 196,0.4)',
    borderRadius: '40px',
    fontSize: '10px',
    width: '101px',
    margin: '5px 5px',
    height: '25px',
    '&:hover': {
      background: 'rgba(138, 245, 196,0.4)',

      color: '#02ab4a',
    },
    // color: '#FFFFFF',
    // background: '#27AE60',
    // borderRadius: 15,
    // fontSize: '10px',
    // fontWeight: 'bold',
    // margin: '0 5px',
    // width: '102px',
  },
  medium: {
    color: '#f17100',
    background: 'rgba(255, 196, 10,0.2)',
    borderRadius: '40px',
    fontSize: '10px',
    margin: '5px 5px',
    width: '101px',
    height: '25px',

    '&:hover': {
      background: 'rgba(255, 196, 10,0.2)',
      color: '#f17100',
    },
    // color: '#FFFFFF',
    // background: '#F2994A',
    // width: '102px',
    // borderRadius: 15,
    // fontSize: '10px',
    // fontWeight: 'bold',
    // margin: '0 5px',
  },
  errorText: {
    color: '#F14B2D',
  },
  greenText: {
    color: '#27AE60',
  },
  gridKenClass: {
    '&  table tbody tr td ': {
      padding: '5px',
    },
    '&  table thead tr th ': {
      fontWeight: 'bold',
      color: '#061938',
    },
  },
}));

const selectOptionsCampus = [
  {
    label: 'Select Campus',
    value: '',
  },
  {
    label: 'Mumbai',
    value: 'Mumbai',
  },
];

const selectOptionsSubject = [
  {
    label: 'Select Program',
    value: '',
  },
  {
    label: 'BBAECO103-Macroeconomics',
    value: 'BBAECO103-Macroeconomics',
  },
];

const selectOptionsReason = [
  {
    label: 'Select Campus',
    value: '',
  },
  {
    label: 'Eligible',
    value: 'Eligible',
  },
  {
    label: 'Not Eligible',
    value: 'Not eligible',
  },
  {
    label: 'At Risk',
    value: 'At Risk',
  },
  {
    label: 'Under Review',
    value: 'Under Review',
  },
];

const selectOptionsTerm = [
  {
    label: 'Select Term',
    value: '--Select--',
  },
  {
    label: 'Term 1',
    value: '1',
  },
  {
    label: 'Term 2',
    value: '2',
  },
];

const selectOptionsBatch = [
  {
    label: 'Select Batch',
    value: '--Select--',
  },
  {
    label: 'Batch 1',
    value: '1',
  },
  {
    label: 'Batch 2',
    value: '2',
  },
];

const UserCellBulkMessage = (row, name) => {
  return (
    <p>
      <img
        style={{ borderRadius: '50%' }}
        width="40"
        height="40"
        src={row}
        alt="user"
      />
      {name}
    </p>
  );
};

const sendBulkDataGrid = [
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Raleigh Avieson'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Fleur Fowler'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Nealy Leitch'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Carolyne Angrock'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Abeu Aiers'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Penny Scrivinor'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Grier Laverick'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Dur Leile'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Claudine Owenson'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Stefa True'
    ),
  },
];

const StudentStatus = () => {
  const history = useHistory();
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);

  const [selectValueCampus, setSelectValueCampus] = useState(
    selectOptionsCampus[0].value
  );
  const [selectValue, setSelectValue] = useState('');
  console.log('setSelectValueCampus', selectValueCampus);
  const handleSelectChangeCampus = (e) => {
    setSelectValueCampus(e.target.value);
  };

  const [selectValueSubject, setSelectValueSubject] = useState(
    selectOptionsSubject[0].value
  );
  const handleSelectChangeProgram = (e) => {
    setSelectValueSubject(e.target.value);
  };

  const [selectValueReason, setSelectValueReason] = useState(
    selectOptionsReason[0].value
  );
  const handleSelectChangeReason = (e) => {
    setSelectValueReason(e.target.value);
  };

  const [selectReason, setSelectReasonTerm] = useState('');
  const handleSelectChangeRes = (e) => {
    setSelectReasonTerm(e.target.value);
  };

  const [selectValueBatch, setSelectValueBatch] = useState(
    selectOptionsBatch[0].value
  );
  const handleSelectChangeBatch = (e) => {
    setSelectValueBatch(e.target.value);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const [filterDialog, setFilterDialog] = useState(false);

  function handleFilterDialog() {
    setFilterDialog((prevState) => !prevState);
  }

  const [sendBulkMessageDialog, setSendBulkMessageDialog] = useState(false);

  function handleSendBulkMessageDialog() {
    setSendBulkMessageDialog((prevState) => !prevState);
  }
  const sendBulkMail = () => {
    sendMailStudentStatus();
    setSendBulkMessageDialog((prevState) => !prevState);
  };
  const attachFileMail = () => {
    console.log('hello world');
  };

  const [selectAllData, setSelectAllData] = useState(false);

  const handleSelectRow = (evt, row, index) => {
    // TODO code here to perform actions on selecting row in table
  };

  const handleSelectAllRows = (state) => {
    // TODO code here to perform actions on selecting all rows in table
    setSelectAllData(state);
  };
  const selectOptionsAllocated = [
    {
      label: 'Eligible',
      value: 'Eligible',
    },
    {
      label: 'Not Eligible',
      value: 'Not eligible',
    },
    {
      label: 'At Risk',
      value: 'At Risk',
    },
    {
      label: 'Under Review',
      value: 'Under Review',
    },
  ];

  // Editing
  const [dataOfTable, setDataOfTable] = useState(data);
  const [isEditing, setIsEditing] = useState(false);
  const [studentStatusData, setStudentStatusData] = useState([]);
  const [messageDialog, setMessageDialog] = useState(false);

  const [selectCourseValue, setCourseValue] = useState('');
  const [selectEligibilityStatusValue, setEligibilityStatusValue] =
    useState('');

  const chatData = [
    {
      sender: true,
      message: `Hey, Could you please let me know which chapters I have to cover
    in UX/UI paper?`,
      profilePic: 'https://ptetutorials.com/images/user-profile.png',
      time: '3 days ago',
    },
    {
      sender: false,
      message: `Hi Nandhini, you should include first 8 chapters in mid semester
      exam.`,
      profilePic: '',
      time: '3 days ago',
    },
    {
      sender: true,
      message: `Okay, Thank you gentleman!`,
      profilePic: 'https://ptetutorials.com/images/user-profile.png',
      time: '3 days ago',
    },
  ];
  const [chats, setChats] = useState(chatData);
  const [previous, setPrevious] = useState({});

  const [typedMessage, setTypedMessage] = useState(
    'Anytime, You are always welcome!'
  );

  // const onToggleEditMode = (check, id, index) => {
  //   // console.log('indexindexindex', index);
  //   setStudentStatusData((state) => {
  //     return studentStatusData.map((row) => {
  //       // console.log('rowrowrowrowrowrow', row);
  //       const newData = [...studentStatusData];

  //       if (row.id === id) {
  //         if (check === 'done') {
  //           const payload = [
  //             {
  //               Id: row.id,
  //               reason: row.reason,
  //               eligibilityStatus: row.eligibility_status,
  //               rollNumber: row.id_no,
  //             },
  //           ];

  //           postStudentStatusData(payload)
  //             .then((res) => {
  //               console.log('resresresres', res);
  //               row.isEditMode = false;
  //               setStudentStatusData(newData);
  //             })
  //             .catch((err) => {
  //               row.isEditMode = false;
  //             });
  //         }
  //         if (check === 'edit') {
  //           return { ...row, isEditMode: !row.isEditMode };
  //         }
  //       }
  //       return row;
  //     });
  //   });
  // };

  const onToggleEditMode = (id) => {
    setStudentStatusData((state) => {
      return studentStatusData.map((row) => {
        if (row.id === id) {
          return { ...row, isEditMode: !row.isEditMode };
        }
        return row;
      });
    });
  };
  const saveData = () => {
    console.log('object');
    const newData = [...studentStatusData];

    const payload = newData.map((row) => {
      return {
        Id: row.id,
        reason: row.reason,
        eligibilityStatus: row.eligibility_status,
        rollNumber: row.id_no,
      };
    });

    postStudentStatusData(payload)
      .then((res) => {
        getStudentData();
      })
      .catch((err) => {
        alert('Failed to add. Please try again.');
      });
  };

  const messageChangeHandler = (e) => {
    setTypedMessage(e.target.value);
  };

  const sendMessageHandler = () => {
    if (!typedMessage) {
      return;
    }

    setChats((prev) => {
      return [
        ...prev,
        {
          sender: false,
          message: typedMessage,
          profilePic: '',
          time: moment(new Date()).fromNow(),
        },
      ];
    });

    setTypedMessage('');
  };
  const onChange = (e, row) => {
    console.log('erow', e, row);
    if (!previous[row.id]) {
      setPrevious((state) => ({ ...state, [row.id]: row }));
    }
    const value = e.target.value;
    const name = e.target.name;
    const { id } = row;
    const newRows = studentStatusData.map((row) => {
      if (row.id === id) {
        return { ...row, [name]: value };
      }
      return row;
    });
    setStudentStatusData(newRows);
  };

  const onToggleEdit = (id, rowes) => {
    setStudentStatusData((state) => {
      return studentStatusData.map((row) => {
        if (row.id === id) {
          return { ...row, isEditMode: !row.isEditMode };
        }
        return row;
      });
    });
  };
  const onRevert = (id) => {
    console.log('studentStatusDatastudentStatusData', id);
    const newRows = studentStatusData.map((row) => {
      console.log('rowrowrowrowrowrowrow', row);

      if (row.id === id) {
        return row;
      }
      return row;
    });
    setStudentStatusData(newRows);
    setPrevious((state) => {
      console.log('statestatestatestate', state);
      delete state[id];
      return state;
    });
    onToggleEdit(id, newRows);
  };

  const getStudentData = () => {
    let filterData = {
      campus: selectValueCampus,
      course: selectValueSubject,
      eligibilityStatus: selectValueReason,
      reason: selectReason,
      filter: selectValue,
    };
    getStudentStatusData(filterData).then((res) => {
      console.log('resForStudentStatus', res);
      const studentInfo =
        res === null
          ? []
          : res.map((item, index) => {
              console.log('itemitem', item);
              return {
                id: item.Id,
                name: item.name ? item.name : 'N/A',
                id_no: item.rollNumber ? item.rollNumber : 'N/A',
                campus: item.campusName ? item.campusName : 'N/A',
                course: item.courseName ? item.courseName : 'N/A',
                eligibility_status: item.eligibilityStatus
                  ? item.eligibilityStatus
                  : 'N/A',
                reason: item.reason ? item.reason : 'N/A',
              };
            });

      setStudentStatusData(studentInfo);
      setFilterDialog(false);
    });
  };

  useEffect(() => {
    getStudentData();
  }, []);

  function handleMessageDialog() {
    setMessageDialog((prevState) => !prevState);
  }
  const handleClickDialoge = () => {
    handleMessageDialog();
  };
  return (
    <Box>
      <ToastContainer />

      <Box className={classes.breadCrumbWrapper}>
        {/* <BreadCrumb array={arrayBreadCrumb} history={history} /> */}
      </Box>
      <AppBar position="static" elevation={0} className={classes.header}>
        <Toolbar
          style={{
            justifyContent: 'space-between',
          }}
        >
          <Typography variant="h6" className={classes.title}>
            Student Status
          </Typography>
          <Grid item xs={6} style={{ display: 'flex', justifyContent: 'end' }}>
            <Button
              startIcon={<Message />}
              variant="contained"
              color="primary"
              className={classes.addButton}
              onClick={handleSendBulkMessageDialog}
              style={{ marginRight: '15px' }}
            >
              Send Bulk Message
            </Button>
            <Button
              startIcon={<RiFilterLine />}
              variant="contained"
              color="primary"
              style={{ marginRight: '15px' }}
              className={classes.addButton}
              onClick={handleFilterDialog}
            >
              Filter
            </Button>
            <Button
              variant="contained"
              color="primary"
              className={classes.addButton}
              style={{
                marginRight: '15px',
                background: '#979797',
                color: 'white',
                fontWeight: 'bold',
                textDecoration: 'none',
                textTransform: 'none',
              }}
              onClick={() => saveData()}
            >
              Save
            </Button>
          </Grid>
        </Toolbar>
      </AppBar>

      {/* <Box className={`cardlsitbox`}>
        <KenCard elevation={0}>
          <KenGrid
            columns={columns}
            data={studentStatusData}
            style={{ padding: '6px 6px', fontWeight: '' }}
            pagination={{ disabled: true }}
            toolbarDisabled={true}
            initialState={{
              hiddenColumns: ['id'],
            }}
            gridProps={{
              getCellProps: (row) => {
                if (
                  row.column.Header === 'Send Message' ||
                  row.column.Header === 'Edit'
                ) {
                  return {
                    style: {
                      textAlign: 'center',
                    },
                  };
                }
                return {
                  style: {
                    textAlign: 'left',
                  },
                };
              },
              getHeaderProps: (column) => {
                if (
                  column.Header === 'Send Message' ||
                  column.Header === 'Edit'
                ) {
                  return {
                    style: {
                      textAlign: 'center',
                    },
                  };
                }
                return {
                  style: {
                    textAlign: 'left',
                  },
                };
              },
            }}
          />
        </KenCard>
      </Box> */}

      <Box className={`cardlsitbox`}>
        <KenCard elevation={0}>
          <Table className={classes.table} aria-label="caption table">
            <TableHead>
              <TableRow>
                <TableCell className="tableHeaderTitle" align="left">
                  NAME
                </TableCell>
                <TableCell className="tableHeaderTitle" align="left">
                  ID NO.
                </TableCell>
                <TableCell className="tableHeaderTitle" align="left">
                  CAMPUS
                </TableCell>
                <TableCell className="tableHeaderTitle" align="left">
                  COURSE
                </TableCell>
                <TableCell className="tableHeaderTitle" align="left">
                  ELIGIBILITY STATUS{' '}
                </TableCell>
                <TableCell className="tableHeaderTitle" align="left">
                  REASON
                </TableCell>

                <TableCell className="tableHeaderTitle" align="left">
                  SEND MESSAGE
                </TableCell>
                <TableCell className="tableHeaderTitle" align="left">
                  EDIT
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {console.log(
                'studentStatusDatastudentStatusData',
                studentStatusData
              )}
              {studentStatusData == null ? (
                <TableCell>
                  <Typography variant="h6" className={classes.dialogHeader}>
                    EXAM FILTER
                  </Typography>
                </TableCell>
              ) : (
                studentStatusData.map((row) => (
                  <TableRow
                    className="editableTableRowData editableTableRowDatas"
                    key={row.id}
                  >
                    {/* <CustomTableCell {...{ row, name: 'name', onChange }} /> */}
                    <KenGridEditableData
                      {...{
                        row,
                        onChange,
                        columns: [
                          {
                            column_name: 'name',
                            is_inline_edit: false,
                            inline_edit_type: '',
                            label: 'name',
                          },
                          {
                            column_name: 'id_no',
                            is_inline_edit: false,
                            inline_edit_type: '',
                            label: 'id_no',
                          },
                          {
                            column_name: 'campus',
                            is_inline_edit: false,
                            inline_edit_type: '',
                            label: 'campus',
                          },
                          {
                            column_name: 'course',
                            is_inline_edit: true,
                            inline_edit_type: '',
                            label: 'course',
                          },
                          {
                            column_name: 'eligibility_status',
                            is_inline_edit: true,
                            inline_edit_type: 'kenSelect',
                            dropdown: selectOptionsAllocated,
                            // label: 'eligibility_status',
                            // style: 'red',
                          },

                          {
                            column_name: 'reason',
                            is_inline_edit: true,
                            inline_edit_type: 'kenInput',
                            // dropdown: selectOptionsAllocated,
                            // label: 'reason',
                          },
                        ],
                      }}
                    />
                    {/* {row.eligibility_status === 'At Risk' ? (
                    <TableCell className={classes.selectTableCell}>
                      <Box>
                        <div style={{ display: 'flex' }}>
                          <Button
                            variant="primary"
                            component={Link}
                            className={classes.error}
                            // to={`${routes.invigilationProctoring}/${id}`}
                          >
                            Not Completed
                          </Button>
                        </div>
                      </Box>
                    </TableCell>
                  ) : (
                    <TableCell className={classes.selectTableCell}>
                      <Box>
                        <div style={{ display: 'flex' }}>
                          <Button
                            variant="primary"
                            component={Link}
                            className={classes.normal}
                            // to={`${routes.seatingPlan}/arrangement/${id}`}
                          >
                            Completed
                          </Button>
                        </div>
                      </Box>
                    </TableCell>
                  )} */}
                    <TableCell className={classes.selectTableCell}>
                      <Box>
                        <div style={{ display: 'flex', paddingLeft: '30%' }}>
                          <Message
                            style={{
                              color: '#092682',
                              cursor: 'pointer',
                            }}
                            onClick={handleClickDialoge}
                            className="m-0"
                            // onClick={handleClick}
                          />
                        </div>
                      </Box>
                    </TableCell>
                    <TableCell className={classes.selectTableCell}>
                      {row.isEditMode ? (
                        <>
                          <IconButton
                            aria-label="done"
                            onClick={() => onToggleEditMode(row.id)}
                          >
                            <DoneIcon />
                          </IconButton>
                          <IconButton
                            aria-label="revert"
                            onClick={() => onRevert(row.id)}
                          >
                            <RevertIcon />
                          </IconButton>
                        </>
                      ) : (
                        <IconButton
                          aria-label="delete"
                          onClick={() => onToggleEditMode(row.id)}
                        >
                          <EditIcon />
                        </IconButton>
                      )}
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </KenCard>
      </Box>

      {/* Filter Modal */}
      <KenDialogBox
        title={
          <Typography variant="h6" className={classes.dialogHeader}>
            EXAM FILTER
          </Typography>
        }
        open={filterDialog}
        handleClose={() => handleFilterDialog()}
        negativeButtonClick={() => handleFilterDialog()}
        positiveButtonClick={() => getStudentData()}
        positiveButtonText="Submit"
        negativeButtonText="Cancel"
        dividers
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Campus"
              options={selectOptionsCampus}
              value={selectValueCampus}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeCampus}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenInputField
              label="Reason"
              value={selectReason}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeRes}
              className="abssssssssss"
              required
            />{' '}
            {/* <KenSelectWrap
              label="Reason"
              options={selectOptionsReason}
              value={selectValueReason}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeReason}
              required
            /> */}
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Course"
              options={selectOptionsSubject}
              value={selectValueSubject}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeProgram}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Eligibility Status"
              options={selectOptionsReason}
              value={selectValueReason}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeReason}
              required
            />
          </Grid>
        </Grid>
      </KenDialogBox>

      {/* Message Modal */}
      <KenDialogBox
        title={
          <Typography variant="h6" className={classes.dialogHeader}>
            Send Bulk Message
          </Typography>
        }
        open={sendBulkMessageDialog}
        handleClose={() => handleSendBulkMessageDialog()}
        negativeButtonClick={() => attachFileMail()}
        positiveButtonClick={() => sendBulkMail()}
        positiveButtonText={<SendIcon />}
        negativeButtonText={<AttachFile />}
        dividers
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <Box className="cardlsitbox">
              <KenCard elevation={0}>
                <Kentable
                  data={sendBulkDataGrid}
                  initialState={{
                    hiddenColumns: ['id'],
                  }}
                  allcheckboxData={(state) => handleSelectAllRows(state)}
                  onRowCheckBox={(event, row, index) =>
                    handleSelectRow(event, row, index)
                  }
                />
              </KenCard>
            </Box>
          </Grid>
          {
            <Grid item xs={12} sm={6}>
              <Box className="cardlsitbox">
                <KenCard elevation={0}>
                  <TextField
                    placeholder="Add Comments"
                    STATUS
                    rows={10}
                    maxRows={'Infinity'}
                  />
                  {/*   <Button variant="contained" component="label">
                  Upload File
                  <input type="file" hidden />
                </Button>
                <input
                  accept="image/*"
                  className={classes.input}
                  style={{ display: 'none' }}
                  id="raised-button-file"
                  multiple
                  type="file"
                />
                <label htmlFor="raised-button-file">
                  <Button
                    variant="raised"
                    component="span"
                    className={classes.button}
                  >
                    Upload
                  </Button>
                </label> */}
                </KenCard>
              </Box>
            </Grid>
          }
        </Grid>
      </KenDialogBox>
    </Box>
  );
};

export default StudentStatus;
